<template>
    <div>
        <div v-if="sections" class="px-4 md:px-0 flex items-center space-x-4 mb-4">
            <h1 class="leading-tight font-bold text-xl md:text-3xl dark:text-white">
                {{ sections[section] }}
            </h1>

            <div v-if="dropdownAttr" class="h-6 block relative" v-click-outside="closeDropdown">
                <div @click="dropdownOpened = !dropdownOpened"
                     class="badge inline-flex space-x-2 m-0 items-center cursor-pointer badge-gray pr-2">
                    <div>{{ getSelectedDropdownName() }}</div>
                    <svg-icon icon="chevron-down" class="w-3 h-3 opacity-50"></svg-icon>
                </div>

                <div v-if="dropdownOpened"
                     class="absolute w-32 top-full left-4 md:left-0 card card-white p-2 shadow text-sm z-100">
                    <div @click="setDropdownValue(opt.value)" v-for="(opt, ind) in dropdownItems" :key="ind"
                         class="cursor-pointer p-1 px-2 rounded"
                         :class="{
                            'bg-gray-100 hover:bg-gray-200 dark:bg-slate-700 dark:hover:bg-slate-600': opt.value === selectedDropdownValue,
                            'hover:bg-gray-100 dark:hover:bg-slate-700': opt.value !== selectedDropdownValue,
                        }"
                    >
                        {{ opt.label }}
                    </div>
                </div>
            </div>
        </div>

        <div v-if="withSort" class="mb-4 px-6 md:px-0 text-sm flex space-x-2 items-center">
            <div @click="setSort(value)" v-for="(label, value) in sort"
                 :class="{'badge-primary' : value === selectedSort, 'badge-gray' : value !== selectedSort}"
                 class="cursor-pointer badge">
                {{ label }}
            </div>
        </div>

        <div ref="scrollContainer">

            <div class="space-y-2 md:space-y-6 mb-2">
                <div v-for="(items, pageKey) in pages"
                     :key="pageKey"
                     :data-page="pageKey"
                     :id="'page-' + pageKey"
                     class="page-container"
                >
                    <div class="space-y-6">
                        <div v-for="(item, index) in items"
                             :key="item.id"
                             :id="'scroll-item-' + item.id"
                             class="observe-item"
                        >
                            <comment
                                    v-if="item.item_type === 'comment'"
                                    class="card card-white"
                                    :data-id="item.id"
                                    :comment="item"
                                    :rate="true"
                                    :short="1"
                                    :post="item.post"
                            ></comment>

                            <post-item
                                    v-if="item.item_type === 'post'"
                                    :post="item"
                                    :data-id="item.id"
                                    @update="items[index] = $event"
                            ></post-item>

                            <user-item
                                    v-if="item.item_type === 'user'"
                                    :user="item"
                                    :data-id="item.id"
                                    :show-rating="1"
                            ></user-item>

                            <channel-item
                                    v-if="item.item_type === 'channel'"
                                    :channel="item"
                            ></channel-item>

                            <block-user-item
                                    v-if="item.item_type === 'blacklist' && item.type === 'user'"
                                    :block="item"
                            ></block-user-item>

                            <block-channel-item
                                    v-if="item.item_type === 'blacklist' && item.type === 'channel'"
                                    :block="item"
                            ></block-channel-item>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="loading"
                 class="rounded-md mx-4 md:mx-0 p-2 bg-slate-200 dark:bg-gray-700 dark:text-gray-300 text-center text-gray-500">
                Паддажи, ебана
            </div>

            <div v-if="!loadUrl"
                 class="rounded-md mx-4 md:mx-0 p-2 bg-slate-200 dark:bg-gray-700 dark:text-gray-300 text-center text-gray-500">
                Записей больше нет!
            </div>

            <div v-if="!hasItems"
                 class="rounded-md mx-4 md:mx-0 p-2 bg-slate-200 dark:bg-gray-700 dark:text-gray-300 text-center text-gray-500">
                {{ emptyMessage || 'Тут пусто' }}
            </div>
        </div>
    </div>
</template>
<script>
import {notify} from "@kyvg/vue3-notification";
import Client from "../../js/modules/Client";
import PullRefresh from 'pull-refresh-vue3';
import BlockUserItem from "./BlockUserItem.vue";
import BlockChannelItem from "./BlockChannelItem.vue";

export default {
	props: [
		'url',
		'type',
		'page',
		'emptyMessage',
		'dontscroll',
		'order',
		'section',
		'sections',
		'withSort',
		'dropdownAttr',
		'dropdownValue',
		'dropdownItems',
	],
	components: {
		BlockChannelItem,
		BlockUserItem,
		PullRefresh
	},
	data() {
		return {
			loadUrl: this.url,
			loading: false,
			pages: {},
			current_page: this.page || 1,
			ob: new IntersectionObserver(this.changeUrl, {
				rootMargin: '-40% 0% -40% 0%'
			}),
			scrolled: false,
			preventLoad: false,
			lastUrl: null,
			hasItems: true,
			firstLoad: true,
			pull: false,
			selectedSort: this.order ?? 'fresh',
			selectedDropdownValue: this.dropdownValue,
			dropdownOpened: false,
			sort: {
				fresh: 'Свежее',
				old: 'Старое',
				best: 'Лучшее',
				worst: 'Худшее',
			},
		};
	},
	beforeUnmount() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	mounted() {

		this.loadPage(this.current_page);

		window.addEventListener("scroll", this.handleScroll);

		setTimeout(() => {
			this.handleScroll();
		}, 1000);

		if (!this.dontscroll) {
			setTimeout(() => {
				let scrollItem = localStorage.getItem('scroll-item');
				let prevUrl = localStorage.getItem('previousUrl');
				let referer = document.referrer;
				let samePage = referer === window.location.href;
				let currentUrl = new URL(window.location.href);
				let currentDomain = currentUrl.hostname;
				let isAnotherSiteReferer = referer && referer.indexOf(currentDomain) === -1;

				if (!referer || samePage || isAnotherSiteReferer) {
					localStorage.removeItem('scroll-item');
					this.scrolled = true;
					return;
				}

				let isPreviousPagePost = prevUrl && prevUrl.match(/\/p\/\d+\/?/)

				if (scrollItem && isPreviousPagePost) {
					window.scrollTo(0, scrollItem - 80);
				}
				localStorage.removeItem('scroll-item');
				this.scrolled = true;
			}, 1000);
		}
	},
	unmounted() {
		if (!this.dontscroll) {
			window.removeEventListener("scroll", this.handleScroll);
		}
	},
	methods: {
		onRefresh() {
			this.loadPage(1);
		},
		changeUrl(entries) {
			let BreakException = {};
			try {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						let element = entry.target;
						let pageContainer = element.closest('.page-container');
						let page = pageContainer.dataset.page;
						let top = element.getBoundingClientRect().top + document.documentElement.scrollTop;
						let offsetTop = top - pageContainer.offsetTop;
						let url = window.location.pathname + (page > 1 ? '?page=' + page : '');

						if (this.lastUrl !== url) {
							this.lastUrl = url;
							window.history.pushState({}, "", url);
						}

						if (this.scrolled) {
							localStorage.setItem('scroll-item', offsetTop);
						}
						throw BreakException;
					}
				});
			} catch (e) {
				if (e !== BreakException) throw e;
			}
		},
		handleScroll() {
			let element = this.$refs.scrollContainer;

			if (element.getBoundingClientRect().bottom < window.innerHeight) {
				this.loadPage(parseInt(this.current_page) + 1);
			}
		},
		getSelectedDropdownName() {
			let filtered = this.dropdownItems.filter((option) => option.value == this.selectedDropdownValue);
			return filtered.length ? filtered[0].label : '';
		},
		resetFeed() {
			this.preventLoad = false;
			this.pages = {};
			this.hasItems = true;
			this.firstLoad = true;
			this.loadPage(1);
		},
		setSort(sort) {
			if (this.selectedSort === sort) {
				return;
			}

			this.selectedSort = sort;
			this.resetFeed();
		},
		setDropdownValue(value) {
			if (this.selectedDropdownValue === value) {
				return;
			}

			this.dropdownOpened = false;
			this.selectedDropdownValue = value;
			this.resetFeed();
		},
		closeDropdown() {
			this.dropdownOpened = false;
		},
		loadPage(page) {
			if (!this.loading && !this.preventLoad) {
				this.loading = true;

				if (this.loadUrl === null) {
					this.loading = false;
					this.pull = false;
				} else {
					let url = new URL(this.loadUrl);
					url.searchParams.append('page', page);

					if (this.withSort) {
						url.searchParams.append('sort', this.selectedSort);
					}

					if (this.dropdownAttr) {
						url.searchParams.append(this.dropdownAttr, this.selectedDropdownValue);
					}

					if (this.current_page !== page) {
						this.current_page = page;
					}

					Client.get(url.href)
						.then(response => {
							this.pages[response.data.meta.current_page] = response.data.data;
							if (!response.data.data.length) {
								this.preventLoad = true;

								if (this.firstLoad) {
									this.hasItems = false;
								}
							}

							if (this.firstLoad) {
								this.firstLoad = false;
							}

							setTimeout(() => {
								document.querySelectorAll('.observe-item').forEach(item => {
									this.ob.unobserve(item)
									this.ob.observe(item)
								});
							}, 500);
						})
						.catch(error => {
							notify({
								type: 'error',
								text: 'Не шмогла я загрузить записи'
							});
							this.preventLoad = true;
						})
						.finally(() => {
							this.loading = false;
							this.pull = false;
						});
				}
			}
		}
	}
}
</script>
